import { render, staticRenderFns } from "./BreadCrumbs.vue?vue&type=template&id=69aefd1e&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Ramon/PROYECTOS/JuanGabriel_POS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69aefd1e')) {
      api.createRecord('69aefd1e', component.options)
    } else {
      api.reload('69aefd1e', component.options)
    }
    module.hot.accept("./BreadCrumbs.vue?vue&type=template&id=69aefd1e&", function () {
      api.rerender('69aefd1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/partials/BreadCrumbs.vue"
export default component.exports